import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { EditorLayout } from "@/components/editor/EditorLayout";
import "./styles.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode><EditorLayout /></StrictMode>,
);
